import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';
import '@mdi/font/css/materialdesignicons.css';
import 'material-symbols';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        appBar: colors.grey.lighten2,
        label: colors.grey.darken2,
        gridLines: colors.grey.lighten2,
        primary: '#162A4F',
        secondary: colors.green,
        accent: colors.amber,
        error: colors.red,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber.darken1,
      },
      dark: {
        appBar: colors.grey.darken3,
        label: colors.grey.lighten4,
        gridLines: colors.grey.darken1,
        primary: colors.blue.darken1,
        secondary: colors.green.lighten1,
        accent: colors.amber,
        error: colors.red.lighten1,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber.darken1,
      },
    },
  },
});
